import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withStyles, Typography, Button } from '@material-ui/core';
import { Redirect } from "react-router-dom"
import History from "../../History"

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        textAlign: 'center',
        marginTop: '10%'
    },
    button: {
        margin: theme.spacing(2)
    }
});


const ProductDontLoading = props => {
    const { classes, translations } = props;
    const [redirect, setRedirect] = useState(null)
    const handleRedirect = () => {
        switch (History?.location?.pathname?.split('/')[1]) {
            case 'pcProduct':
                setRedirect('/products/pc-products')
                return;
            case 'mobileProduct':
                setRedirect('/products/mobile-products')
                return;
            case 'storageProduct':
                setRedirect('/products/storage-products')
                return;
            default:
                return;
        }
    }
    if (redirect) return <Redirect to={redirect} />

    return (<div className={classes.root}>
        <Typography color="primary" variant="h1">
            404
        </Typography>
        <Typography color="primary" variant="h3">
            {translations['requested_product_was_not_found'] || 'Requested product was not found'}
        </Typography>
        <Button className={classes.button} variant={"outlined"} color={"primary"} onClick={handleRedirect}>
            {translations['go_to_product'] || 'Go to product'}
        </Button>
    </div>
    );
}

const mapStateToProps = state => {
    return {
        translations: state?.translate?.translations?.activeTranslations ?? {},
    };
};

export default connect(
    mapStateToProps,
    null
)(withStyles(styles, { withTheme: true })(ProductDontLoading));